define('Loyality.Confirmation.View',
[
    'loyality_confirmation.tpl',
    'underscore',
    'Backbone'
],
function (loyality_confirmation,
          _,
          Backbone) {

    'use strict';

    return Backbone.View.extend({


        template: loyality_confirmation

        , initialize: function (options) {
        }

        , getContext: function () {
            return {
            };
        }

    })
})
